module.exports = __webpack_public_path__ + "b0eb4cd264d38d8eb8cafaf2e71b9118.MP3";